const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'stts_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_STTSS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_STTSS':
      return {
        ...state,
        sort: action.sort
      }
    case 'FILTER_STTSS':
      return {
        ...state,
        filter: action.filter
      }
    case 'SEARCH_STTSS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_STTS':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.stts_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sttss.js